import { useLayoutEffect, useRef, useState } from 'react'

import type { ElementCallback, OnChangeText, UseTextArea } from './types'
import type { RefCallBack } from 'react-hook-form'

export const useTextArea: UseTextArea = ({
  shouldExpandWithText,
  onChange,
  ref,
}) => {
  const localRef = useRef<Element | null>(null)
  useLayoutEffect(() => {
    updateScrollHeight(localRef.current)
  }, [localRef.current])

  const [scrollHeight, setScrollHeight] = useState(0)
  const updateScrollHeight: ElementCallback = (element) => {
    if (element && shouldExpandWithText) {
      setScrollHeight(element.scrollHeight)
    }
  }
  const onChangeText: OnChangeText = (event) => {
    updateScrollHeight(event.target)
    onChange?.(event)
  }

  const handleRef: ElementCallback = (element) => {
    updateScrollHeight(element)
    const r = ref as RefCallBack
    r?.(element)
    if (!localRef.current) localRef.current = element
  }

  return {
    scrollHeight,
    onChangeText,
    handleRef,
  }
}
